import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

export const SpinnerComponent = styled(CircularProgress).attrs(() => ({
    size: 30
}))`
    color: #ffffff;
    position: absolute;
`;
